import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, PaginationType } from '@typings/requestPayloads'

export interface IListEmailCredentialPayload {
    pagination?: PaginationType
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const list = createSlice({
    name: 'email-credential/list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListEmailCredentialPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        },
        onRemoveItem(state, action) {
            state.data = state.data.filter(item => item._id !== action.payload)
        },
        onEditItem(state, action) {
            const newData = [...state.data]
            const item = newData.find(item => item._id === action.payload._id)
            for (const key in action.payload) {
                item[key] = action.payload[key]
            }
            state.data = newData
        },
        onAddItem(state, action) {
            state.data = [...state.data, action.payload]
        }
    }
})

export const listActions = list.actions
export default list.reducer
